import React from "react";
import Loader from 'react-loader-spinner'
// import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import { FormBuilderObjects } from "../../variables/formBuilderData";
import HttpServices from "../../utils/Http.services";

class ParamsInput extends React.Component {
    state = {
        options: [],
        isLoading: false
    }

    componentDidMount() {
        this.init(true)
    }


    componentDidUpdate(prevProps) {

        if (this.props.params != prevProps.params) {
            this.init()
        }

        if (this.props.data != prevProps.data) {
            this.init()
        }

        // console.log(this.props.header?.information?.frame)

        if (this.props.header?.information?.frame != this.state?.frame || (this.props.header?.information?.frame && !this.state.frame)) {

            // console.log(this.props.header?.information?.frame)

            this.fetchFields()
        }
    }


    fetchFields = () => {

        this.setState({ frame: this.props.header?.information?.frame })

        if (!this.props.header?.information?.local && this.props.header?.information?.frame) {
            let body = { filter: {} }

            if (!Array.isArray(this.props.header?.information?.frame)) {
                body.filter._id = [this.props.header?.information?.frame]
            } else {
                body.filter._id = this.props.header?.information?.frame
            }

            // console.log("fetchFields")
            // console.log("getFrame!", body)

            HttpServices.request('getFrames', body, (fetchResult, fetchError) => {

                // console.log(fetchResult, fetchError)

                this.setState({ isLoadingHeaders: false })
                if (fetchError) {
                    this.setState({ fetchError })
                    return
                }

                // let fields = fetchResult?.info?.fields

                // console.log(fetchResult.info)

                // let params =  []
                let myParams

                if (Array.isArray(fetchResult.info)) {
                    fetchResult.info.forEach(frame => {
                        if (!myParams) {
                            myParams = { label: "Current Record", value: '*record', fields: frame?.fields, info: fetchResult.info }
                        } else {

                            if (Array.isArray(frame?.fields)) {



                                frame.fields.forEach(frameField => {
                                    let found = false
                                    let myParamsFields = myParams.fields ?? []

                                    myParamsFields.forEach(paramField => {

                                        // console.log(paramField)
                                        if (frameField.information?.label == paramField.information?.label) {
                                            found = true
                                        }
                                    });

                                    if (!found) {
                                        myParams.fields.push(frameField)
                                    }

                                });



                                let foundId = false

                                for (let a = 0; a < myParams.length; a++) {
                                    const element = myParams[a];
                                    if (element?.key == '_id') {
                                        foundId = true
                                    }
                                }

                                if (!foundId) {
                                    myParams.splice(0, 0, { key: '_id', type: 'TextInput', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID' } })
                                    myParams.push({ key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation date', } })
                                    myParams.push({ key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Update date', } })
                                }
                            }
                            // myParams.fields = [...(myParams.fields ?? []), ...(frame?.fields ?? [])]
                        }
                    });
                }

                console.log(myParams)
                // let myParams = { label: "View Record", value: 'record', fields: fetchResult.info?.fields, info: fetchResult.info }

                this.setState({ myParams }, () => {
                    this.init()
                })



            })
        }

    }

    init(mount) {
        let refParams = this.props.params ? JSON.parse(JSON.stringify(this.props.params)) : []

        if (this.state.myParams) {
            refParams.splice(0, 0, this.state.myParams)
        }

        console.log(this.props.params)


        if (refParams) {

            let params = []
            let choosen
            refParams.forEach(item => {
                let paramIsValid = false
                let validTypes = this.props.header.information?.validTypes ?? null

                if (item.fields) {
                    item.fields.forEach(field => {

                        if (!validTypes || validTypes.includes(field.type)) {

                            if (!paramIsValid) {
                                paramIsValid = true
                                let param = { ...item }
                                param.fields = []
                                params.push(param)
                            }
                            let value = "{{" + checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label) + "}}"
                            let title = checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label)


                            // console.log(value)
                            // console.log(this.props.data)

                            if (value == this.props.data) {

                                choosen = {
                                    value: value,
                                    title: title
                                }
                            }


                            params[params.length - 1].fields.push(field)
                        }
                    });
                }
            });

            // console.log(choosen)

            this.setState({ params, choosen })
            // let value = item ? "{{" + item.label + ' - ' + field.information?.label + "}}" : null
            // let title = item ? item.label + ' - ' + field.information?.label : null

        }

    }



    toggleOpen = (open) => {
        let openState = open != null ? open : !this.state.isOpen

        if (openState) {
            this.fixedView.showView()
        } else {
            this.fixedView.hideView()
        }

        this.setState({ isOpen: openState })

    }



    changeValue = (item, field) => {

        let value = item ? "{{" + checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label) + "}}" : null
        let title = item ? checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label) : null
        // console.log(e.target.value)
        // let value = e.target.value
        // if (value == '') {
        //     value = null
        // }
        // console.log('this.props.header.key',this.props.header.key)
        // console.log(value)
        this.props.changeValue(this.props.header.key, value, this.props.extra)
        this.toggleOpen(false)
        this.setState({ choosen: value ? { title, value } : null })
    }


    render() {
        let dataValue = ''
        if (this.props.data) {
            dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        }

        // console.log(this.props.params)

        return (
            <div className='w-100' style={{ position: 'relative' }}>
                <div style={{ position: 'relative' }} ref={el => this.currentNode = el}  >
                    <div className="w-100 h-100 cursor-pointer" onClick={() => this.toggleOpen(true)}>
                        {this.state.choosen ? (
                            <p className="text-small">{this.state.choosen?.title}</p>
                        ) : (
                            <p className="text-small placeholder">{this.props.header.information.placeholder ? checkTextTranslation(this.props.header.information.placeholder) : translate('Select...')}</p>
                        )}
                    </div>

                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={0} zIndex={15} xOffset={-2} rightAlign={false} maxWidth={250}>

                        <div className="w-100 br-8 px-2 py-2" style={{ backgroundColor: '#fff', boxShadow: '0px 0px 20px #10101020', maxHeight: 270, overflow: 'auto' }}>

                            <button className=" flexcb w-100 text-smaller text-start mt-2 pb-2" style={{ cursor: 'pointer', borderBottom: '1px solid #eee' }} onClick={() => { this.changeValue(null, null) }}>
                                <div className='flexc px-1'>
                                    {/* <img draggable={false} src={FormBuilderObjects[field.type]?.icon} className='br-20 mrd-3' width={20} style={{ filter: 'grayscale(0%)' }} /> */}
                                    <p draggable={false} className=" text-bold text-small">{this.props.header.information.placeholder ? checkTranslation(this.props.header.information.placeholder) : translate("Select...")}</p>
                                </div>

                                {/* <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 ' /> */}
                            </button>

                            {this.state.params?.map((item, index) => {
                                return (
                                    <div className=" pt-2 pb-2 w-100 " key={item.value} style={{ borderBottom: '0px solid #eee' }}>
                                        <div className="px-1">
                                            <p draggable={false} className=" text-bold text-small">{translate(item.label)}</p>
                                        </div>
                                        <div className="px-1">
                                            {item.fields?.map((field, index) => {
                                                return (

                                                    <button className=" flexcb w-100 text-smaller text-start mt-2" style={{ cursor: 'pointer', }} onClick={() => { this.changeValue(item, field) }}>
                                                        <div className='flexc'>
                                                            <img draggable={false} src={FormBuilderObjects[field.type]?.icon} className='br-20 mrd-3' width={20} style={{ filter: 'grayscale(0%)' }} />
                                                            <p draggable={false} className=" text-semibold text-smaller">{translate(field.information?.label)}</p>
                                                        </div>

                                                        {/* <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 ' /> */}

                                                    </button>
                                                )
                                            })}
                                        </div>

                                    </div>
                                );
                            })}
                        </div>
                    </FixedView>


                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: -2, right: 0 }}>
                            <Loader
                                type="ThreeDots"
                                color="#9ab"
                                height="25"
                                width="25"
                            />
                        </div>
                    )}

                </div>

            </div>
        );
    }
}

export default ParamsInput;
